module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_2000-cf04615bb30f0bd83e9ca73b21a4ea1c.png";